// extracted by mini-css-extract-plugin
export default {"mainCard":"fo-z","products":"go-z","title":"ho-z","heading_section":"io-z"};